import React from 'react';
import { Modal, Form, Input } from 'antd';
import type { Admin } from '../types/admin.types';

interface MfaResetModalProps {
    open: boolean;
    loading: boolean;
    admin: Admin | null;
    onCancel: () => void;
    onSubmit: (id: string, reason: string) => void;
}

export const MfaResetModal: React.FC<MfaResetModalProps> = ({
    open,
    loading,
    admin,
    onCancel,
    onSubmit
}) => {
    const [form] = Form.useForm();

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    const handleOk = () => {
        form.submit();
    };

    const handleFinish = (values: { reason: string }) => {
        if (admin) {
            onSubmit(admin.id, values.reason);
            form.resetFields();
        }
    };

    return (
        <Modal
            title="Reset MFA"
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    name="reason"
                    label="Reason"
                    rules={[
                        { required: true, message: 'Please provide a reason' },
                        { min: 5, message: 'Reason must be at least 5 characters' }
                    ]}
                >
                    <Input.TextArea rows={3} placeholder="Enter reason for MFA reset (minimum 5 characters)" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
